export const data = {
  imgAlt: 'People shopping in a store',
  title: 'Who did you buy it from?',
  productPlaceholder: 'e.g. Currys, Amazon',
  placeholder: 'e.g. Carpetright, Anglian',
  serviceImage:
    'https://media.product.which.co.uk/prod/images/original/a81b91984d56-tooliconpin.jpg',
  image: 'https://media.product.which.co.uk/prod/images/original/498f33d717e0-tooliconstore.jpg',
}
